module.exports = __webpack_public_path__ + "static/media/sweden.35e461a7.png";